/**
 * Author: David Rodríguez
 * Date: 06/02/2029
 * Modified: 07/08/2020
 * Version: 0.0.1
 */
import Transformer from './../transformer'
import assetURL from '../../utils/assetURL'

class SinistersTrandformer extends Transformer {
  static fetch(sinister) {
    return {
      id: sinister.id,
      sinisterNumber: sinister.sinister_number,
      folioJB: sinister.folio_jb,
      requisitionNumber: sinister.requisition_number,
      roadsID: sinister.roads_id,
    }
  }
}

class PurchaseOrderTransformer extends Transformer {
  static fetch(order) {
    return {
      amount: Number(order.amount),
      folio: order.folio,
      status: order.status,
      pdf: assetURL(order.pdf),
      sinisters: order.sinisters.map(SinistersTrandformer.fetch),
    }
  }
}

export default class InvoiceTransformer extends Transformer {
  static fetch(invoice) {
    return {
      id: invoice.id,
      folio: invoice.folio,
      providerName: invoice.provider.name,
      providerCommercialName: invoice.provider.commercial_name,
      providerRFC: invoice.provider.rfc,
      providerNumber: invoice.provider.provider_number,
      pdfFile: assetURL(invoice.pdf_file),
      xmlFile: assetURL(invoice.xml_file),
      status: invoice.status,
      subtotal: invoice.subtotal,
      total: invoice.total,
      addDate: invoice.add_date,
      ocurredDate: invoice.date,
      orders: invoice.orders.map(PurchaseOrderTransformer.fetch),
      showOrders: true,
      uuid: invoice.uuid,
      serie: invoice.serie,
      cfdiType: invoice.cfdi_type,
      version: invoice.version,
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/purchase/invoice.js